// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__GqtkK","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2hxbA","obliqueLine":"membershipbadge_obliqueLine__3B_C6"};